import { render, staticRenderFns } from "./EmailNewsletter.vue?vue&type=template&id=495ae987&"
import script from "./EmailNewsletter.vue?vue&type=script&lang=js&"
export * from "./EmailNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports